<ion-footer>
  <ion-buttons>
    <ion-button
      *ngFor="let button of buttons"
      [class.hidden]="button.isHidden"
      (click)="button.onClicked()"
      [fill]="button.fill"
      [color]="button.color"
      [disabled]="button.isDisabled"
    >
      {{ button.text | translate }}
    </ion-button>
  </ion-buttons>
</ion-footer>
